<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Avatar :src="userAvator"/>
      <Icon :size="12" type="arrow-down-b"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="webHome">返回首页</DropdownItem>
        <DropdownItem name="corp" v-if="permissionState">企业设置</DropdownItem>
        <DropdownItem name="account">个人设置</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
import { encryptionSignResult } from '@/libs/tools'
import { accountInfo } from '@/api/data'
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  data(){
    return{
      permissionState:false,
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.handleLogOut().then(() => {
            this.$router.push({
              name: 'webHome'
            })
          });
          break;
        case 'webHome':
          this.$router.push({
            name: 'webHome'
          });
          break;
        case 'account':
          this.$router.push({
            name: 'account',
          });
          break;
        case 'corp':
          this.$router.push({
            name: 'corp',
          });
          break
      }
    },
    //
  },
  mounted(){
    this.permissionState = this.$store.state.user.access.some(item=>{
      return item === 26;
    });
  },
}
</script>



// WEBPACK FOOTER //
// src/view/main/components/user/user.vue